"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrderingMenuHomepage',
  data: function data() {
    return {
      carouselImages: ['http://img3.gagacafe.com//images/pub_images/start_diagram/2025082719490844493_680.png', 'http://img3.gagacafe.com//images/pub_images/start_diagram/2025081811580897884_680.png', 'http://img2.gagacafe.com//images/pub_images/start_diagram/2025090311240988754_680.png'],
      userInfo: {
        avatar: 'https://dummyimage.com/80x80/ff6b6b/ffffff&text=Avatar',
        name: '用户名',
        memberLevelIcon: 'https://dummyimage.com/60x20/ffd43b/000000&text=Gold',
        points: 1000,
        vouchers: 5,
        balance: 200.00,
        memberCode: 'https://dummyimage.com/80x80/000/fff&text=Code'
      },
      orderTypes: {
        dineIn: {
          icon: 'https://dummyimage.com/50x50/4ecdc4/000000&text=In',
          text: '堂食',
          textEn: 'Eat In'
        },
        takeaway: {
          icon: 'https://dummyimage.com/50x50/ff6b6b/000000&text=Go',
          text: '自提',
          textEn: 'To Go'
        },
        delivery: {
          icon: 'https://dummyimage.com/50x50/45b7d1/000000&text=Del',
          text: '外卖',
          textEn: 'Delivery'
        }
      },
      diamondItems: {
        reserve: {
          icon: 'https://dummyimage.com/40x40/ffd93d/000000&text=Pre',
          text: '预点',
          textEn: 'Pre-Order'
        },
        group: {
          icon: 'https://dummyimage.com/40x40/6decb9/000000&text=Group',
          text: '拼单',
          textEn: 'Group Order'
        }
      },
      announcement: {
        icon: 'https://dummyimage.com/20x20/ff9a3c/000000&text=!',
        text: '最新公告：今日特惠套餐上线，快来品尝！',
        hasNew: true
      },
      bottomText: '餐厅名称 版权所有',
      navItems: [{
        name: '首页',
        icon: 'https://dummyimage.com/30x30/000/fff&text=Home'
      }, {
        name: '菜单',
        icon: 'https://dummyimage.com/30x30/000/fff&text=Menu'
      }, {
        name: '订单',
        icon: 'https://dummyimage.com/30x30/000/fff&text=Order'
      }, {
        name: '我的',
        icon: 'https://dummyimage.com/30x30/000/fff&text=Me'
      }]
    };
  },
  methods: {
    selectOrderType: function selectOrderType(type) {
      console.log('Selected order type:', type);
      // 处理订单类型选择逻辑
    },
    handlePreOrder: function handlePreOrder() {
      console.log('Handle pre-order');
      // 处理预点逻辑
    },
    handleGroupOrder: function handleGroupOrder() {
      console.log('Handle group order');
      // 处理拼单逻辑
    },
    handleNavClick: function handleNavClick(item) {
      console.log('Nav item clicked:', item.name);
      // 处理导航点击逻辑
    }
  }
};